var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMentorsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.570312,
    y: 0.5,
    width: 48,
    height: 48,
    rx: 4,
    fill: "#AECD5E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_130",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5703,
    y: 12.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8703 29.2L29.2703 27.8L25.5703 24.1V19.5H23.5703V24.9L27.8703 29.2ZM24.5703 34.5C23.187 34.5 21.887 34.2373 20.6703 33.712C19.4536 33.1873 18.3953 32.475 17.4953 31.575C16.5953 30.675 15.883 29.6167 15.3583 28.4C14.833 27.1833 14.5703 25.8833 14.5703 24.5C14.5703 23.1167 14.833 21.8167 15.3583 20.6C15.883 19.3833 16.5953 18.325 17.4953 17.425C18.3953 16.525 19.4536 15.8123 20.6703 15.287C21.887 14.7623 23.187 14.5 24.5703 14.5C25.9536 14.5 27.2536 14.7623 28.4703 15.287C29.687 15.8123 30.7453 16.525 31.6453 17.425C32.5453 18.325 33.2576 19.3833 33.7823 20.6C34.3076 21.8167 34.5703 23.1167 34.5703 24.5C34.5703 25.8833 34.3076 27.1833 33.7823 28.4C33.2576 29.6167 32.5453 30.675 31.6453 31.575C30.7453 32.475 29.687 33.1873 28.4703 33.712C27.2536 34.2373 25.9536 34.5 24.5703 34.5Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorsIcon);
export default __webpack_public_path__ + "static/media/mentors-icon.7ee50f7822b52c0d7472a462d09f80c2.svg";
export { ForwardRef as ReactComponent };